import { useState, useEffect } from 'react';

const navLinks = [
  { href: '#ranking', label: '吃瓜热度榜' },
  { href: '#index', label: '吃瓜专题合集' },
  { href: '#features', label: '平台优势' },
  { href: '#updates', label: '最新快讯' },
  { href: '#cards', label: '热点事件' },
  { href: '#comments', label: '网友热议' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navTextClass = scrolled ? 'text-foreground-600 hover:text-primary-600' : 'text-background-50/80 hover:text-background-50';
  const navTextClassActive = scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50 hover:text-background-50';
  const menuIconClass = scrolled ? 'text-foreground-700' : 'text-background-50';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#" className="flex items-center gap-2 group cursor-pointer" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <span className={`text-xl md:text-2xl font-heading font-bold whitespace-nowrap transition-colors ${
              scrolled ? 'text-primary-600' : 'text-primary-400'
            }`}>
              911爆料网
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className={`px-3 py-2 text-sm font-medium transition-colors rounded-md whitespace-nowrap cursor-pointer ${navTextClassActive}`}
            >
              首页
            </a>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className={`px-3 py-2 text-sm font-medium transition-colors rounded-md whitespace-nowrap cursor-pointer ${navTextClass}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${menuIconClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); setMobileOpen(false); }}
              className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md cursor-pointer"
            >
              首页
            </a>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors rounded-md cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}